import {useEffect} from 'react';
import {useLocation} from 'react-router-dom';
import {
  CONTENT_LAB_FLOW_ROUTES,
  CONTENT_LAB_ROUTES,
  ROUTES,
} from '@contentlab/config/routesConstants';
import AnalyticsService, {
  eventNames,
} from '@/services/analytics/AnalyticsService';
import usePrevious from '@/hooks/use-previous';

function usePageViewEvent() {
  const location = useLocation();
  const previousLocation: any = usePrevious(location);

  const isDeltaInitialized =
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    !!AnalyticsService.getProvider('delta')?.getRegularAttributes?.()?.brand_id;

  const getContentLabPageName = (pathname: string) => {
    if (!pathname) {
      return CONTENT_LAB_ROUTES[ROUTES.CONTENT_LAB];
    }

    const matchingRoute = Object.entries(CONTENT_LAB_FLOW_ROUTES).find(
      (entry) => entry[0] && pathname.includes(entry[0])
    );
    if (matchingRoute) {
      return matchingRoute[1];
    }
    return CONTENT_LAB_ROUTES[ROUTES.CONTENT_LAB];
  };

  useEffect(() => {
    if (!isDeltaInitialized) {
      return;
    }

    if (
      !previousLocation?.pathname?.includes(ROUTES.CONTENT_LAB) &&
      !location.pathname?.includes(ROUTES.CONTENT_LAB)
    ) {
      return;
    }

    const pageName = getContentLabPageName(location.pathname);
    const previousPageName = getContentLabPageName(previousLocation?.pathname);

    let flow_id;
    if (Object.values(CONTENT_LAB_FLOW_ROUTES).includes(pageName)) {
      flow_id = AnalyticsService.getOrCreateFlow(pageName).flow_id;
    }
    if (
      Object.values(CONTENT_LAB_FLOW_ROUTES).includes(previousPageName) &&
      previousPageName !== pageName
    ) {
      AnalyticsService.endFlow(previousPageName);
    }
    AnalyticsService.dispatchEvent(eventNames.CONTENT_STUDIO_PAGE_VIEW, {
      page_name: pageName,
      page_url: location.pathname,
      referrer_url: previousLocation?.pathname || '',
      flow_id: flow_id || '',
    });
  }, [location.pathname, isDeltaInitialized]);

  return null;
}

export default usePageViewEvent;
